import styled from "styled-components"

import { spacing } from "@izettle/otto"

import { focusOutlineMixin } from "../../../mixins"
import { IconButtonProps } from "../types"

import { IconButtonColorCss } from "./variants"

export const sizes = {
  small: "20px",
  medium: "24px",
  large: "28px",
}

const FOCUS_BORDER_WIDTH = "1px"

const getIconButtonSize = ({ size = "medium" }: IconButtonProps) => sizes[size]
const getVariant = ({ variant = "primary" }: IconButtonProps) =>
  IconButtonColorCss[variant]

export const IconButtonBase = styled.button.attrs(({ title }: IconButtonProps) => ({
  "aria-label": title,
  type: "button",
}))<IconButtonProps>`
  position: relative;
  font-size: ${getIconButtonSize};
  padding: ${spacing.tiny};
  line-height: 1;

  cursor: pointer;

  border: ${FOCUS_BORDER_WIDTH} solid;
  border-radius: 100%;

  transition-duration: 0.1s;
  transition-timing-function: ease;
  transition-property: background-color, border-color, color;

  background-color: transparent;
  border-color: transparent;
  ${getVariant};

  &:focus {
    ${focusOutlineMixin}
  }

  &:disabled {
    cursor: not-allowed;
    background-color: transparent;
    border-color: transparent;
  }

  /* override global portal styles */
  height: unset;
  -webkit-font-smoothing: unset;
`

export const IconMouseClickFocusRemover = styled.div.attrs({ tabIndex: -1 })`
  height: calc(100% + ${FOCUS_BORDER_WIDTH} * 2);
  width: calc(100% + ${FOCUS_BORDER_WIDTH} * 2);
  top: -${FOCUS_BORDER_WIDTH};
  left: -${FOCUS_BORDER_WIDTH};
  position: absolute;
  z-index: 1;
  border-radius: inherit;

  &:focus {
    outline: none;
    &::-moz-focus-inner {
      border: 0;
    }
  }
`
